import { Native, env } from '@hb/hbridge';
import { ILoginResult } from '@/types/common';

interface ILoginReadyOptions {
  needLogin?: boolean;
  resetLogin?: boolean;
}

let getTokenAndKeyPromise: Promise<boolean> | null = null;
class AppLoginModel {
  loginResult: ILoginResult = Object.create(null);

  loadGoogleScriptStatus: boolean = false;

  /**
 * 异步处理登录准备逻辑
 * @param options 登录准备选项，默认为空对象
 * @property {boolean} needLogin 是否需要登录
 * @returns {Promise<boolean>} 返回一个Promise，解析为true表示登录准备就绪，否则表示失败或不需要登录
 * 
 * 此方法用于处理登录准备逻辑，主要检查环境变量、应用类型、登录凭据等，
 * 并在必要时发起获取token和key的请求。在开发环境下会使用模拟数据。
 */
  async onLoginReady(options: ILoginReadyOptions = {}) {
    // 提取选项中的needLogin属性，用于决定是否需要登录
    const { needLogin } = options;
    // 提取登录结果中的token和ticket
    const { token, ticket } = this.loginResult;

    // 开发环境下，使用模拟的登录结果数据
    // if (!env.isHelloPetApp && process.env.NODE_ENV === 'development') {
    //   this.loginResult = {
    //     token: 'd0d7648bd6694fde9fd3075011803d4e',
    //     ticket: 'MTczMTQ5ODcyOQ==.SCbdY8DFldEKBSv4qD7f2feK2aku/E7Rq1Y50LMcwsM=',
    //     guid: '2ef4cba1fb834edbb16854853194ef51',
    //   };
    //   return Promise.resolve(true);
    // }

    // 如果不是HelloPet应用环境，则直接返回false，表示不需要登录
    if (env.isHelloPetApp === false) {
      return false;
    }

    // 如果已经有有效的token和ticket，则表示登录准备就绪
    if (token && ticket) {
      return Promise.resolve(true);
    }

    // 如果已经有正在进行的获取token和key的请求Promise，则直接返回该Promise
    if (getTokenAndKeyPromise && !options.resetLogin) {
      return getTokenAndKeyPromise;
    }

    // 初始化获取token和key的请求Promise
    getTokenAndKeyPromise = Native.getTokenAndKey({
      needLogin: !!needLogin,
    }).then((res) => {
      // 请求成功，更新登录结果
      this.loginResult = res;
      return true;
    }).catch((error) => {
      // 请求失败，清空登录结果，并返回失败标志
      this.loginResult = Object.create(null);
      return false;
    });

    // 返回获取token和key的请求Promise
    return getTokenAndKeyPromise;
  }

  isLogin() {
    const { token, ticket } = this.loginResult;
    return !!(token && ticket);
  }

  getLoginResult(options: ILoginReadyOptions = {}) {
    if (this.isLogin()) {
      return Promise.resolve(this.loginResult);
    }
    return this.onLoginReady(options).then(() => this.loginResult);
  }

  setLoadGoogleStatus(status: boolean) {
    this.loadGoogleScriptStatus = status;
  }
}

export default new AppLoginModel();
